import * as serviceActions from '../../actions/services';
import * as fetchingState from '../../constants/fetchingState';

export default function (state, action) {

    switch (action.type) {
        case serviceActions.FETCH_SERVICES: {
            return { ...state, fetching: fetchingState.FETCHING };
        }
        case serviceActions.SUCCESS_FETCH_SERVICES: {
            if (!action.data.error)
                return { ...state, fetching: fetchingState.FETCHED, services: action.data };
        }
        case serviceActions.FAILURE_FETCH_SERVICES: {
            return { ...state, fetching: fetchingState.FAILED };
        }
        case serviceActions.UPDATE_SERVICE: {
            return { ...state, updateFetching: fetchingState.FETCHING };
        }
        case serviceActions.SUCCESS_UPDATE_SERVICE: {
            if (!action.data.error)
                return { ...state, updateFetching: fetchingState.FETCHED };
        }
        case serviceActions.FAILURE_UPDATE_SERVICE: {
            return { ...state, updateFetching: fetchingState.FAILED, updateResult: action.data.error };
        }
        case serviceActions.CLEAR_UPDATE_SERVICE: {
            return { ...state, updateFetching: fetchingState.INITIAL, updateResult: undefined };
        }
        case serviceActions.CREATE_SERVICE: {
            return { ...state, createFetching: fetchingState.FETCHING };
        }
        case serviceActions.SUCCESS_CREATE_SERVICE: {
            if (!action.data.error)
                return { ...state, createFetching: fetchingState.FETCHED };
        }
        case serviceActions.FAILURE_CREATE_SERVICE: {
            return { ...state, createFetching: fetchingState.FAILED, createResult: action.data.error };
        }
        case serviceActions.CLEAR_CREATE_SERVICE: {
            return { ...state, createFetching: fetchingState.INITIAL, createResult: undefined };
        }
        default: return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/serviceCategory/serviceReducer.js